/**
 * Mapping of screen names to their corresponding page names.
 * @type {object}
 */
const screens = {
  homeTabs: 'homeTabs',
  onboarding: 'onboarding',
  homeDrawer: 'homeDrawer',
  sharedArticle: 'shared-article',
  sharedChat: 'shared-chat',
  auth: {
    login: 'loginPage',
    forgetPassword: 'forgetPasswordPage',
    resetPassword: 'resetPasswordPage',
    register: 'registerPage',
    verificationPending: 'verificationPendingPage',
  },
  content: {
    forYou: 'forYouPage',
    favorite: 'favoritePage',
    favoriteRoutes: 'favoriteRoutes',
    genio: 'genio',
    library: 'libraryPage',
    topics: 'topicsPage',
    documents: 'documentsPage',
    addNote: 'addNotePage',
    viewNote: 'viewNotePage',
    home: 'homePage',
    homeTab: 'homeTab',
    fileViewer: 'fileViewerPage',
    notes: 'notesPage',
    notesRoutes: 'notesRoutes',
    news: 'newsPage',
    notifications: 'notificationsPage',
    article: 'articlePage',
    latestArticle: 'latestArticlePage',
    latest: 'latestPage',
    tabNews: 'tabNewsPage',
    chooseYourSpeciality: 'chooseYourSpecialityPage',
    privacyPolicy: 'privacyPolicyPage',
    privacyPolicyForm: 'privacyPolicyFormPage',
    termsConditions: 'termsConditionsPage',
    settings: 'settingsPage',
    profile: 'profilePage',
    profileRoutes: 'profileRoutes',
    changePassword: 'changePasswordPage',
    fontSize: 'fontSizePage',
    darkMode: 'darkMode',
    customerSupport: 'customerSupportPage',
    changeLanguage: 'changeLanguagePage',
    filters: 'filtersPage',
    calculators: 'calculatorsPage',
    search: 'SearchPage',
    voiceInteractionRoute: 'voiceInteractionPageRoute',
    voiceInteraction: 'voiceInteractionPage',
    summaries: 'summariesPage',
    afterLogin: 'afterLoginPage',
    drugs: 'drugsPage',
    drugsDiseases: 'drugsDiseasesPage',
    drugsDiseasesDetails: 'drugsDiseasesDetailsPage',
    drugsDetails: 'drugsDetailsPage',
    customizeHome: 'customizeHomePage',
    genioChat: 'genioChatPage',
    enterClinicalCase: 'enterClinicalCasePage',
    genioChatRoutes: 'genioChatRoutes',
    medicalUpdates: 'medicalUpdates',
    clinicalCaseRoutes: 'clinicalCaseRoutes',
    clinicalCase: 'clinicalCase',
    filterTabNews: 'filterTabNews',
    tabNewsResults: 'tabNewsResults',
    medicalUpdatesCongresses: 'medicalUpdatesCongresses',
    patientsRoutes: 'patientsRoutes',
    patients: 'patients',
    viewPatient: 'viewPatient',
    addEditPatient: 'addEditPatient',
    addEditPatientReport: 'addEditPatientReport',
    viewPatientReport: 'viewPatientReport',
    logout: 'logout',
  },
};

export default screens;
